import Pikaday from 'pikaday';

export default class Search {
  constructor(el) {
    this.DOM = { el: el };
    this.datepicker = new Datepicker(document.querySelector('#js-datepicker'));
    this.DOM.dateField = this.DOM.el.querySelector('#js-datepicker');
    this.DOM.daysField = this.DOM.el.querySelector('select[name="SearchHaku"]');
    this.DOM.guestsField = this.DOM.el.querySelector('select[name="SearchNin"]');
    this.DOM.roomsField = this.DOM.el.querySelector('select[name="SearchHeya"]');
    this.DOM.submit = this.DOM.el.querySelector('#search-submit');

    this.getSearchVals = this.getSearchVals.bind(this);
    this.openUrl = this.openUrl.bind(this);

    this.init();
  }

  init() {
    if (!this.DOM.el) return;
    this.datepicker.init();
    this.bindEvents();
  }

  bindEvents() {
    this.DOM.submit.addEventListener('click', this.openUrl);
  }

  getSearchVals() {
    const checkinDate = this.DOM.dateField.value;
    const checkinYear = checkinDate.split('/')[0];
    const checkinMonth = checkinDate.split('/')[1];
    const checkinDay = checkinDate.split('/')[2];
    const numDays = this.DOM.daysField.value;
    const numGuests = this.DOM.guestsField.value;
    const numRooms = this.DOM.roomsField.value;

    return { checkinYear, checkinMonth, checkinDay, numDays, numGuests, numRooms };
  }

  openUrl() {
    const { checkinYear, checkinMonth, checkinDay, numDays, numGuests, numRooms } = this.getSearchVals();
    const targetURL = `
      https://www.jhpds.net/ichinomata-gh/uw/uwp3100/uww3101.do?yadNo=303583
      &stayYear=${checkinYear}
      &adultNum=${numGuests}
      &roomCount=${numRooms}
      &stayMonth=${checkinMonth}
      &stayDay=${checkinDay}
      &stayCount=${numDays}
    `.replace(/\s/g, '');

    window.open(targetURL, "_blank");
  }
}

class Datepicker {
  constructor(el) {
    this.DOM = { el: el };
    this.config = {
      format: 'YYYY/MM/DD',
      defaultDate: new Date(),
      setDefaultDate: new Date(),
      minDate: new Date(),
      toString(date, format) {
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        const year = date.getFullYear();
        return `${year}/${month}/${day}`;
      },
      parse(dateString, format) {
        const parts = dateString.split('/');
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1] - 1, 10);
        const year = parseInt(parts[1], 10);
        return new Date(year, month, day);
      },
      i18n: {
        previousMonth : 'Previous Month',
        nextMonth     : 'Next Month',
        months        : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
        weekdays      : ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
        weekdaysShort : ['日','月','火','水','木','金','土']
      },
      yearSuffix: '年',
      showMonthAfterYear: true,
      numberOfMonths: 2
    };
  }

  init() {
    if (!this.DOM.el) return;

    return new Pikaday({...this.config, field: this.DOM.el});
  }
}
